import { axios, Response } from '../../index'
import { CreateFavoriteTaskRequest } from './requests/create-favorite-task-request'
import { CreateFavoriteTaskResponse } from './responses/create-favorite-task-response'

const createFavoriteTask = (
  body: CreateFavoriteTaskRequest
): Response<CreateFavoriteTaskResponse[]> => {
  return axios.post('/v1/favorites/favorites-tasks', body)
}

export default createFavoriteTask
